"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.create.title': 'Utwórz Nowy Krok',
};
